import { useCallback } from 'react'
import { AuthService } from '../services/authService'
import { AUTH_ACTIONS } from '../contexts/auth/authTypes'

export const useAuthActions = (dispatch) => {
  const checkAuthStatus = useCallback(async () => {
    try {
      dispatch({ type: AUTH_ACTIONS.SET_LOADING })

      const result = await AuthService.checkAuthStatus()

      if (result.authenticated) {
        dispatch({
          type: AUTH_ACTIONS.SET_AUTHENTICATED,
          payload: { user: result.user }
        })
      } else {
        dispatch({ type: AUTH_ACTIONS.SET_UNAUTHENTICATED })
      }
    } catch (error) {
      dispatch({ type: AUTH_ACTIONS.SET_UNAUTHENTICATED })
    }
  }, [dispatch])

  const getCurrentUser = useCallback(async () => {
    try {
      const user = await AuthService.getCurrentUser()

      dispatch({
        type: AUTH_ACTIONS.UPDATE_USER,
        payload: { user }
      })

      return user
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Get current user failed:', error)
      throw error
    }
  }, [dispatch])

  const loginWithEmail = useCallback(async (email, password) => {
    try {
      dispatch({ type: AUTH_ACTIONS.SET_LOADING })

      const result = await AuthService.loginWithEmail(email, password)

      if (result.success) {
        dispatch({
          type: AUTH_ACTIONS.SET_AUTHENTICATED,
          payload: { user: result.user }
        })
        return { success: true, user: result.user }
      } else {
        dispatch({
          type: AUTH_ACTIONS.SET_ERROR,
          payload: { error: result.error }
        })
        return { success: false, error: result.error }
      }
    } catch (error) {
      const errorMessage = error.message || 'Login failed. Please try again.'
      dispatch({
        type: AUTH_ACTIONS.SET_ERROR,
        payload: { error: errorMessage }
      })
      return { success: false, error: errorMessage }
    }
  }, [dispatch])

  const registerWithEmail = useCallback(async (userData) => {
    try {
      dispatch({ type: AUTH_ACTIONS.SET_LOADING })

      const result = await AuthService.registerWithEmail(userData)

      if (result.success) {
        dispatch({
          type: AUTH_ACTIONS.SET_AUTHENTICATED,
          payload: { user: result.user }
        })
        return { success: true, user: result.user }
      } else {
        dispatch({
          type: AUTH_ACTIONS.SET_ERROR,
          payload: { error: result.error }
        })
        return { success: false, error: result.error }
      }
    } catch (error) {
      const errorMessage = error.message || 'Registration failed. Please try again.'
      dispatch({
        type: AUTH_ACTIONS.SET_ERROR,
        payload: { error: errorMessage }
      })
      return { success: false, error: errorMessage }
    }
  }, [dispatch])

  const loginWithGoogle = useCallback(() => {
    AuthService.loginWithGoogle()
  }, [])

  const loginWithDiscord = useCallback(() => {
    AuthService.loginWithDiscord()
  }, [])

  const loginWithFacebook = useCallback(() => {
    AuthService.loginWithFacebook()
  }, [])

  const loginWithMicrosoft = useCallback(() => {
    AuthService.loginWithMicrosoft()
  }, [])

  const logout = useCallback(async () => {
    dispatch({ type: AUTH_ACTIONS.SET_UNAUTHENTICATED })
    await AuthService.logout()
  }, [dispatch])

  const clearError = useCallback(() => {
    dispatch({ type: AUTH_ACTIONS.CLEAR_ERROR })
  }, [dispatch])

  return {
    checkAuthStatus,
    getCurrentUser,
    loginWithEmail,
    registerWithEmail,
    loginWithGoogle,
    loginWithDiscord,
    loginWithFacebook,
    loginWithMicrosoft,
    logout,
    clearError
  }
}